import { useQuery } from '@tanstack/react-query';
import { journalsQueries } from "@entities/journal";
import { useCoordinator } from "@shared/lib/hooks";

export const useGetFirstEmptySection = () => {
  const { titleId } = useCoordinator() as { titleId: string };
  const { data } = useQuery(journalsQueries.getTitleJournal({ titleId }));

  const journal = data?.mainJournal?.titleJournal;

  const checkSection = (sectionId: string): boolean => {
    switch (sectionId) {
      case 'journals-info':
        return !journal?.mainJournalNumber;
      case 'developer-company':
        return !journal?.developer?.company?.companyId;
      case 'tec-customer-company':
        return !journal?.technicalCustomer?.company?.companyId;
      case 'building-contractor-company':
        return !journal?.buildingContractor?.company?.companyId;
      case 'designer-supervisions':
        return !journal?.designerSupervisions || journal.designerSupervisions.length === 0;
      case 'other-developers':
        return !journal?.otherDevelopers || journal.otherDevelopers.length === 0;
      case 'documentation-contractor-company':
        return !journal?.projectDocumentationContractor?.company?.companyId;
      default:
        return false;
    }
  };

  const sectionIds = [
    'journals-info',
    'developer-company',
    'building-contractor-company',
    'documentation-contractor-company',
    'tec-customer-company',
    'designer-supervisions',
    'other-developers',
  ];

  const firstEmpty = sectionIds.find((id) => checkSection(id));
  return firstEmpty || 'journals-info';
};
